export default class Routes {

    static getTitle(title: string): string {
        try {
            if (title === '/general/inicio') {
                return 'Início';
            } else if (title === '/general/home') {
                return 'Home';
            } else if (title === '/general/minhaConta') {
                return 'Editar Conta';
            } else if (title === '/general/cartoesDependentes') {
                return 'Cartões MEEP';
            } else if (title === '/general/produtos') {
                return 'Produtos';
            } else if (title === '/general/cadastrarProduto') {
                return 'Cadastrar produtos';
            } else if (title === '/general/categorias') {
                return 'Categorias';
            } else if (title === '/general/venda-produto') {
                return 'Venda de produto';
            } else if (title === '/general/extrato') {
                return 'Extrato';
            }  else if (title === '/general/dependentes') {
                return 'Dependentes';
            }  else if (title === '/general/cartoes') {
                return 'Cartões de crédito';
            } else if (title === '/general/registrarCartao') {
                return 'Registrar Cartão';
            } else if (title === '/general/financeiro') {
                return 'Financeiro';
            } else if (title === '/general/faleConosco') {
                return 'Fale conosco';
            } else if (title === '/general/registrarDependente') {
                return 'Registrar Cartão';
            } else if (title === '/general/cartoesDependentes') {
                return 'Cartões dependentes';
            } else if (title === '/general/consumo') {
                return 'Consumo';
            } else if (title === '/general/descricaoPiramide') {
                return 'Pirâmide alimentar';
            } else {
                const titleSplit = title.split(':')[0].split('general/')[1].split('/');
                if (titleSplit[0] === 'extrato') {
                    return 'Extrato';
                } else if (titleSplit[0] === 'recarga') {
                    return 'Recarga';
                } else if (titleSplit[0] === 'reembolso') {
                    return 'Dados bancários para reembolso';
                } else if (titleSplit[0] === 'registrarDependente') {
                    return 'Editar Cadastro';
                } else if (titleSplit[0] === 'limiteDiario') {
                    return 'Limite diário';
                } else if (titleSplit[0] === 'recargaAutomatica') {
                    return 'Recarga automática';
                } else if (titleSplit[0] === 'alterarSenha') {
                    return 'Alterar dados';
                } else if (titleSplit[0] === 'consumo') {
                    return 'Consumo';
                }  else if (titleSplit[0] === 'nutricional') {
                    return 'Nutricional';
                } else if (titleSplit[0] === 'dependentesSingle') {
                    if (titleSplit[2] === 'restricoes' && titleSplit.length === 4 ) {
                        return 'Cardápio';
                    } else if (titleSplit[4] === 'restricaoSingle' && titleSplit.length === 6) {
                        return 'Produtos';
                    } else if (titleSplit[2] === 'nutricional' && titleSplit.length === 4) {
                        return 'Nutricional';
                    } else {
                        return 'Dados do cartão';
                    }
                } else if (titleSplit[0] === 'duplicatePay') {
                    return 'Solicitação de segunda via';
                } else {
                    return 'Meep';
                }
            }
        } catch (err) {
            return 'Meep';
        }
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/helpers/routes.ts